import React from 'react';
import { Button, Label, Remark, ActionButton } from 'fw/components';
import { Row, Col, FormGroup } from 'react-bootstrap';
import { ContentHeader, ContentBody } from 'areas/shared/components';
import { PhoneBox, BestContactTimeCombo, TimeZoneCombo } from 'areas/shared/controls'
import API from 'fw/system/API';
import * as FormManager from 'fw/forms/form/FormManager'
import * as Notifications from 'fw/globals/Notifications';
import { Form, EmailBox, TextBox, Switch } from 'fw/forms';
import * as APIModules from 'modules/app/API';
import * as App from 'modules/app/App';
import * as Modals from 'fw/globals/Modals';

class SponsorUserInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState(props);
    }

    initialState(props) {
        return {
            originalEmail: '',
			disabled: true,
			adding: false,
            sponsorId: props.sponsorId,
            userId: props.userId,
            form: { userName: '' }
        };
    }

    handleCancel = () => {
        FormManager.checkUnsavedChanges(() => {
            if (this.props.onCancel)
                this.props.onCancel();
        })
    }

    componentDidMount() {
        this.loadUser(this.state.userId);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.userId !== this.props.userId)
            this.loadUser(nextProps.userId);
    }

    loadUser = (userId) => {

        if (userId === 0) {
            this.setState({
                userId: userId,
                disableSave: false,
				adding: true,
				disabled: !App.hasPrivilege("SponsorSetupUserAdd"),
				originalPrimaryContactValue: false,
                form: { userName: 'New User' }
            });
            return;
        }

        var rq = {
            userId: userId,
			sponsorId: this.props.sponsorId
        };

        new API().get(APIModules.Sponsor.url('/sponsorSetup/getSponsorManagementUserInfo'), rq,
            {
                success: (r) => {
                    // Store search results
                    this.setState({
						adding: false,
						disabled: !App.hasPrivilege("SponsorSetupUserEdit"),
						originalPrimaryContactValue: r.data.primaryContact,
                        form: r.data
                    });
                }
            });

    }

	handleSave = () => {
		const me = this;

		// Primary Contact changed from false to true
		if(!this.state.originalPrimaryContactValue && this.state.form.primaryContact)
			Modals.confirm(
				"Only one Primary Point of Contact can be selected; setting an Admin user as Primary Contact will replace the previous one. <br /><br />" +
				"If you wish to continue, please select 'Yes'. <br /><br />" +
				"If you wish to Discard this change, please select 'No', and you will be returned to the previous screen.",
				function () {
					me.handleSubmit();
				});
		else
			this.handleSubmit();
	}


    handleSubmit = () => {
        if (this.state.isValidated && !this._form.validate())
            return false;

        // Proceed
        var url = APIModules.Sponsor.url('/sponsorSetup/saveSponsorManagementUserInfo');
		var form = this.state.form;

        let rq = {
            sponsorId: this.props.sponsorId,
            userId: form.userId,
            oldUserId: form.oldUserId,
            firstName: form.firstName,
            lastName: form.lastName,
            email: form.email,
            title: form.title,
			primaryPhone: form.primaryPhone,
			secondaryPhone: form.secondaryPhone,
			bestContactTimeCode: form.bestContactTimeCode,
			timeZoneCode: form.timeZoneCode,
			primaryContact: form.primaryContact,
			originalPrimaryContactValue: this.state.originalPrimaryContactValue,
			adminRights: form.adminRights,
            rowVersion: form.rowVersion
        };

        this.setState({
            saving: true
        }, function () {
            new API().post(url, rq, {
                success: (r) => {
                    Notifications.success(r.message);

                    this.setState({
                        dirty: false,
                        form: {
                            ...this.state.form,
                            ...r.data,
                            original: {
                                ...this.state.form,
                                ...r.data
                            }
                        }
                    }, this.props.onUpdate());
                    FormManager.reset();
                },
                error: r => {
                    Notifications.error(r.error.errorMessage);
                }
            })
        });
    }

    emailFocus = () => {
        this.setState({
            originalEmail: this.state.form.email,
            disableSave: true
        });
    }

    emailChange = () => {
		const me = this;

        if (this.state.originalEmail !== this.state.form.email) {
            var rq = {
                sponsorId: this.props.sponsorId,
                userId: this.state.form.userId,
                email: this.state.form.email
            };

            new API().post(APIModules.Sponsor.url('/sponsorSetup/validateUserEmail'), rq, {
                success: (r) => {
                    if (r.data != null) {
						// Set UserId to null
						me.setState({
							form: {
								...me.state.form,
								userId: 0
							}
						});

						// Confirm if founded user will be used
						Modals.confirm(
							"A Corporate Member user with the same Email Address was found in the database. <br /><br />" +
							"If you wish to associate this user to the Corporate Member, please select 'Yes'. <br /><br />" +
							"If you wish to Discard this change, please select 'No', and you will be returned to the previous screen.",
							function () {
								me.setState({
									disabled: false, // Review
									form: {
										...me.state.form,
										...r.data
									}
								});
							}
						);
                    }
                },
                error: r => {
                    Notifications.error(r.error.errorMessage);
                }
            });
        }
    }

    handleChange = (form, callback) => {
        this.setState({ form }, callback);
    }

    handleDelete = () => {
        const me = this;

        var rq = {
            sponsorId: this.props.sponsorId,
            userId: this.state.form.userId,
            rowVersion: this.state.form.rowVersion
        };

        Modals.confirm(
            "Removing this User will remove this User from the User's 'Corporate Member' tab. <br /><br />" +
			"Please be advised, this User will also be marked as 'Inactive' within the system, and their access to VOCS will be removed.  <br /><br />" +
            "If you wish to remove this User, please select 'Yes'. <br /><br />" +
            "If you wish to Discard this change, please select 'No', and you will be returned to the previous screen.",
            function () {
                new API().post(APIModules.Sponsor.url('/sponsorSetup/removeSponsorManagementUserAssociation'), rq,
                    {
                        success: (r) => {
                            Notifications.success(r.message);
                            FormManager.reset();
                            me.props.onUpdate()
                        },
                        error: (r) => {
                            Notifications.error(r.error.errorMessage);
                        }
                    });
            });
    }

    handleResendRegistration = () => {
        var rq = {
            userId: this.state.form.userId
        };

        Modals.confirm("This will resend the registration email for this user. Are you sure?", function () {
            new API().post(APIModules.Security.url('/registration/resendRegistration'), rq, {
                success: (r) => {
                    Notifications.success(r.message);
                },
                error: (r) => {
                    Notifications.error(r.error.errorMessage);
                }
            });
        });
    }

    renderActions() {
        if (this.state.userId === 0)
            return null;

        return (
            <div className="pull-right">
                {(App.hasPrivilege("SponsorSetupUserEdit") && this.state.form.registrationPending) &&
                    <ActionButton id="btnResendRegistration" onClick={this.handleResendRegistration} icon="envelope">Resend Registration</ActionButton>
                }
                {App.hasPrivilege("SponsorSetupUserRemove") && this.state.userId !== 0 &&
                    <ActionButton id="btRemoveAssociation" onClick={this.handleDelete} icon="trash">Remove User</ActionButton>
                }
            </div>
        )
    }

    render() {
        const me = this;
        return (
            <React.Fragment>
                <ContentHeader title={this.state.form.userName}>
                </ContentHeader>
                <ContentBody>
                    <Row>
                        <Col md={12}>
                            <hr style={{ height: "1px", background: "#333" }} />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={10}>
                            <Form
                                onChange={this.handleChange}
                                values={this.state.form}
                                unsavedChangesWarning={true}
                                ref={(form) => { this._form = form }}
								disabled={this.state.disabled} >
                                <Row>
                                    <Col md={4}>
										<FormGroup>
                                            <Label required>Email</Label>
                                            <EmailBox
                                                name="email"
                                                placeholder="Email"
                                                maxLength={255}
                                                required
                                                onBlur={this.emailChange}
                                                onFocus={this.emailFocus}
                                                ref={(c) => { this.focusControl = c; }} />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label required>First Name</Label>
                                            <TextBox
                                                name="firstName"
                                                placeholder="First Name"
                                                maxLength={30}
                                                required />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label required>Last Name</Label>
                                            <TextBox
                                                name="lastName"
                                                placeholder="Last Name"
                                                maxLength={30}
                                                required />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label required>Title</Label>
                                            <TextBox
                                                name="title"
                                                placeholder="Title"
                                                maxLength={200}
                                                required />
                                        </FormGroup>
										<FormGroup>
											<Row>
												<Col md={6} style={{ paddingTop: "5px" }}>
													<Label>Primary Contact</Label>
												</Col>
												<Col md={6}>
													<Switch 
														name='primaryContact' 
														labelLeft='No' 
														labelRight='Yes' 
														bsStyle='success' />
												</Col>
											</Row>
											<Row>
												<Col md={6} style={{ paddingTop: "5px" }}>
													<Label>Admin Rights</Label>
												</Col>
												<Col md={6}>
													<Switch 
														name='adminRights' 
														labelLeft='No' 
														labelRight='Yes' 
														bsStyle='success'
														disabled={App.context().userId === me.state.form.userId || this.state.disabled} />
												</Col>
											</Row>
										</FormGroup>
                                    </Col>
									<Col md={5}>
										<FormGroup>
											<Label required>Primary Phone</Label>
											<div className="form-inline">
												<PhoneBox 
													name="primaryPhone" 
													required
													showExtension />
											</div>
										</FormGroup>
										<FormGroup>
											<Label>Secondary Phone</Label>
											<div className="form-inline">
												<PhoneBox 
													name="secondaryPhone"
													showExtension />
											</div>
										</FormGroup>
										<FormGroup>
											<Label required>Best Time to be Contacted</Label>
											<BestContactTimeCombo name="bestContactTimeCode" required />
										</FormGroup>
										<FormGroup>
											<Label required>Which Time Zone are you located?</Label>
											<TimeZoneCombo name="timeZoneCode" required />
										</FormGroup>
									</Col>
                                </Row>
                                {!this.state.adding && this.state.form.registrationPending &&
                                    <Row>
                                        <FormGroup bsClass="col-md-10">
                                            <Remark message="(*) This user has not completed registration yet." />
                                        </FormGroup>
                                    </Row>
                                }
                            </Form>
                        </Col>
                        <Col md={2}>
                            {this.renderActions && this.renderActions()}
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <div className="pull-right">
                                <Button id="btnCancel" bsStyle="link" onClick={() => this.handleCancel()}>Cancel</Button>
                                <Button id="btnSave" onClick={this.handleSave} bsStyle="primary" disabled={this.state.disabled}>Save</Button>
                            </div>
                        </Col>
                    </Row>
                </ContentBody>
            </React.Fragment>
        )
    }
}

export default SponsorUserInfo;


// WEBPACK FOOTER //
// ./src/areas/sponsor/sponsorSetup/users/SponsorUserInfo.js